import { NavigationSettingAri } from '@atlassian/ari/navigation';

const MENU_DATA_KEY = 'nav-plat-l1-menu-data' as const;
const SIDE_BAR_DATA_KEY = 'nav-plat-sidebar-data' as const;

type BuildSettingsEntityAriParamsInternal = {
	activationId: string;
	firstPartyApp: string;
	settingId: string;
	siteId: string;
};

export type BuildSettingsEntityAriParams = Omit<BuildSettingsEntityAriParamsInternal, 'settingId'>;

export function buildNavigationAriForMenuData(
	params: Omit<BuildSettingsEntityAriParams, 'settingId'>,
): string {
	return buildNavigationAri({ ...params, settingId: MENU_DATA_KEY });
}

export function buildNavigationAriForSidebarData(
	params: Omit<BuildSettingsEntityAriParams, 'settingId'>,
): string {
	return buildNavigationAri({ ...params, settingId: SIDE_BAR_DATA_KEY });
}

function buildNavigationAri(params: BuildSettingsEntityAriParamsInternal) {
	return homeOverride(NavigationSettingAri.create(adjustParams(params)).toString());
}

// For the time being (Sept 2025), Home will be the only townsquare app that stores network settings.
// The other apps (Goals, Teams &Projects) are in the process of being individually commissioned
// (meaning they will have their own siteId and/or activationId). In the meantime, they will NOT
// be using the settings service, so we don't need an override for them.
function adjustParams(params: BuildSettingsEntityAriParamsInternal) {
	if (params.firstPartyApp === 'home') {
		return {
			...params,
			settingId: `${params.settingId}-${params.firstPartyApp}`,
		};
	}
	return params;
}

function homeOverride(ari: string) {
	return ari.replace('/home/', '/townsquare/');
}
